import React from 'react';
import './SHEventInfoBox.css';
import { useLanguage } from '../../../../../LanguageProvider';
import { TbMapPin, TbWorld, TbTicket } from 'react-icons/tb';

export default function SHEventInfoBox({ event, channelTitle, channelLogo, participantCount = 0, soldTicketsCount = 0, style, isPreview = false }) {
    const { getTranslation } = useLanguage();
    const monthKeys = [
        getTranslation("january"),
        getTranslation("february"),
        getTranslation("march"),
        getTranslation("april"),
        getTranslation("may"),
        getTranslation("june"),
        getTranslation("july"),
        getTranslation("august"),
        getTranslation("september"),
        getTranslation("october"),
        getTranslation("november"),
        getTranslation("december"),
    ];

    function formatToMonthDayWeekday(timestamp) {
        const date = new Date(timestamp * 1000);
        const monthKey = monthKeys[date.getMonth()];
        const monthName = getTranslation(monthKey); // örn. "October" veya "Ekim"
        const day = String(date.getDate()).padStart(2, '0'); // "03"
        const weekdayKey = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'][date.getDay()];
        const weekdayName = getTranslation(weekdayKey); // örn. "Saturday" veya "Cumartesi"
        return `${monthName} ${day} ${weekdayName}`;
    }

    function formatTime(timestamp) {
        const date = new Date(timestamp * 1000);
        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const isAM = hours < 12;

        const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
        const suffix = isAM ? getTranslation("am") : getTranslation("pm");

        return `${formattedHours}:${minutes} ${suffix}`;
    }

    const monthName = () => {
        const date = new Date(event.eventStartDateTime * 1000);
        const monthKey = monthKeys[date.getMonth()];
        return monthKey.substring(0, 3); // İlk 3 harf
    }

    function date() {
        const date = new Date(event.eventStartDateTime * 1000);
        const day = String(date.getDate()).padStart(2, '0'); // "03"

        return day;
    }

    // Tarih ve saat aralığını formatla
    const startDateStr = event?.eventStartDateTime ? formatToMonthDayWeekday(event.eventStartDateTime) : '';
    const startTimeStr = event?.eventStartDateTime ? formatTime(event.eventStartDateTime) : '';
    const endTimeStr = event?.eventEndDateTime ? formatTime(event.eventEndDateTime) : '';

    // Konum metnini belirle
    const locationText = event?.locationAddress && event.locationAddress.trim() !== ''
        ? event.locationAddress
        : (event?.isOnline === "1" ? event?.website || 'Online Event' : '');

    return (
        <div className="sh-event-info-box-container" style={style}>
            <div className='sh-event-info-box-card' >

                {isPreview ? (
                    <>
                        <span className='sh-event-info-box-title' style={{ textAlign: 'left' }}>
                            {event?.title}
                        </span>
                        <span className='sh-event-info-box-channel-title' style={{ width: '100%', boxSizing: 'border-box', border: 'none' }}>
                            <img width={'45px'} height="auto" style={{ display: 'block', borderRadius: '4px' }} src={channelLogo} alt="Channel Logo" />
                            {channelTitle}
                        </span>
                    </>
                ) : (
                    <>
                        <span className='sh-event-info-box-channel-title' style={{ width: '100%', boxSizing: 'border-box' }}>
                            {channelLogo && <img width={'45px'} height="auto" style={{ display: 'block', borderRadius: '4px' }} src={channelLogo} alt="Channel Logo" />}
                            {channelTitle}
                        </span>
                        <span className='sh-event-info-box-title'>
                            {event?.title}
                        </span>
                    </>
                )}

                <div style={{ flexDirection: 'row', display: 'flex', gap: '15px', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>

                    <div className='sh-event-info-box-date-box'>
                        <div className='sh-event-info-box-date-box-month'>
                            {monthName()}
                        </div>
                        <div className='sh-event-info-box-date-box-date'>
                            {date()}
                        </div>

                    </div>

                    <div className="sh-event-date-time">
                        <span>
                            <strong>{startDateStr}</strong> <br />
                            <span className="sh-event-time">{startTimeStr} - {endTimeStr}</span>
                        </span>
                    </div>
                    <div className='sh-event-info-box-location-box'>
                        {event.isOnline === "1" ? (
                            <TbWorld size={24} />
                        ) : (
                            <a
                                href={`https://www.google.com/maps?q=${event.locationLatitude},${event.locationLongitude}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: 'inherit', cursor: 'var(--pointer)', display: "flex", justifyContent: 'center', alignItems: 'center' }}
                            >
                                <TbMapPin size={24} />
                            </a>
                        )}
                    </div>

                    {locationText && (
                        <div title={locationText} className="sh-event-location">
                            {event.isOnline === "1" ?
                                <span>{locationText}</span> :

                                <a
                                    href={`https://www.google.com/maps?q=${event.locationLatitude},${event.locationLongitude}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ color: 'inherit', cursor: 'var(--pointer)', textDecoration: 'none' }}
                                >{locationText}</a>
                            }
                        </div>
                    )}

                    {/* Sold tickets count - only show in preview mode (register page) */}
                    {isPreview && soldTicketsCount > 0 && (
                        <>
                            <div className='sh-event-info-box-location-box'>
                                <TbTicket size={24} />
                            </div>
                            <div className="sh-event-location">
                                <span>{soldTicketsCount} {getTranslation('peopleAttending')}</span>
                            </div>
                        </>
                    )}
                </div>

            </div>
        </div>
    );
}